var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BAlert',{staticClass:"mb-0",attrs:{"show":"","variant":"primary"}},[_c('div',{staticClass:"d-flex"},[_c('i',{staticClass:"fas fa-info-circle mr-2 mt-1"}),_c('p',{staticClass:"mb-0",staticStyle:{"font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.$t('activities.productionReconciliation.arithmeticExpressionsInfoBoxText'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }